import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../CoinsAllotments/CoinAllotmentList.css";
import axios from "axios";
import { Api } from "../../../BackendApi/api";
import ConfirmPopup from "../../../Component/ConfirmPopup/ConfirmPopup";

const EditCoinOverlay = ({ coinData, onClose, onSave }) => {
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });
  const [formData, setFormData] = useState({
    customer: "",
    dateTime: new Date(),
    coins: "",
    remarks: "",
    transType: "IN",
    status: "ACTIVE",
    billInfo: "",
  });

  const customerInputRef = useRef(null);

  useEffect(() => {
    if (customerInputRef.current) {
      customerInputRef.current.focus();
    }
  }, [coinData]);
  useEffect(() => {
    if (!coinData) return;
    setFormData((prev) => ({
      ...prev,
      customer: coinData.customer || prev.customer,
      customerId: coinData.id || prev.customerId,
      dateTime: coinData.DateTime || coinData.datetime
        ? new Date(coinData.DateTime || coinData.datetime)
        : prev.dateTime,
      TransNo: coinData.TransNo || coinData.transactionNo || prev.TransNo,
      billInfo: coinData.BillInfo || coinData.billInfo || prev.billInfo,
      coins: coinData.coins || prev.coins,
      remarks: coinData.transactionremarks || prev.remarks,
      transType: coinData.TransType === "IN" ? "ALLOT" : "DEDUCT",
      status:
        coinData.status?.toLowerCase() === "active" ? "ACTIVE" : "Deactive",
    }));
  }, []);


  const fetchCustomers = async (search) => {
    if (!search.trim()) {
      setCustomers([]);
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axios.post(
        `${Api.baseurl}/getcustomers`,
        {
          searchstring: search,
          startfrom: 0,
          limit: 50,
          SortColumn: "CreatedAt",
          SortOrder: -1,
          Status: "ACTIVE",
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const customerArray = response.data.data || response.data.customers || [];
      setCustomers(
        customerArray.map((cust) => ({
          id: cust._id,
          name: cust.CustName || "N/A",
          coins: cust.CustCurrentCoins || 0,
        }))
      );
      setShowDropdown(true);
    } catch (err) {
      console.error("Error fetching customers:", err);
    } finally {
      setLoading(false);
    }
  };

  let typingTimer;
  const handleCustomerInput = (e) => {
    const value = e.target.value;
    setFormData({ ...formData, customer: value });
    clearTimeout(typingTimer);
    typingTimer = setTimeout(() => fetchCustomers(value), 500);
  };

  const handleSelectCustomer = (cust) => {
    setFormData({ ...formData, customer: cust.name, customerId: cust.id });
    setCustomers([]);
    setShowDropdown(false);
  };

  const handleSubmit = async (type) => {
    if (!formData.customer || !formData.coins) {
      alert("Please select customer and enter coins");
      return;
    }
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      const payload = {
        _id: coinData._id || coinData.id,
        CustName: formData.customer,
        TransValue: Number(formData.coins),
        TransType: type,
        TransDesc: formData.remarks || "Coins Transaction",
        DateTime: formData.dateTime,
        Status: formData.status,
        BillInfo: formData.billInfo || "",
      };

      const res = await axios.post(Api.editCoinAllot, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (res.data.success || res.data.status === 1) {
        const successMessage = `Coins ${type === "IN" ? "Allotted" : "Deducted"
          } Successfully`;

        setPopup({
          show: true,
          message: successMessage,
          type: "success",
        });
      } else {
        setPopup({
          show: true,
          message: res.data.message || "Transaction failed",
          type: "error",
        });
      }
    } catch (err) {
      console.error(err);
      setPopup({ show: true, message: "Something went wrong", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  return (
    <div className="coinallot-overlay">
      <div className="coinallot-overlay-content">
        {/* Header with static transaction number */}
        <div style={{ position: "relative", width: "100%" }}>
          <h2>Edit Coin Transaction</h2>
          <span className="transaction-number">
            Transaction No: {formData.TransNo || "N/A"}
          </span>
        </div>
        <form
          className="coinallot-overlay-form"
          onSubmit={(e) => e.preventDefault()}
        >
          {/* Customer Field */}
          <label>
            Customer
            <div className="customer-field" style={{ position: "relative" }}>
              <input
                ref={customerInputRef}
                type="text"
                value={formData.customer}
                onChange={handleCustomerInput}
                placeholder="Enter Customer Name"
                onFocus={() => formData.customer && setShowDropdown(true)}
              />
              {showDropdown && customers.length > 0 && (
                <div className="customer-dropdown">
                  {loading ? (
                    <div>Searching...</div>
                  ) : (
                    customers.map((cust) => (
                      <div
                        key={cust.id}
                        className="customer-option"
                        onClick={() => handleSelectCustomer(cust)}
                      >
                        {cust.name} - Coins: {cust.coins}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </label>

          {/* Date & Time */}
          <label>
            Date & Time
            <DatePicker
              selected={formData.dateTime}
              onChange={(date) => setFormData({ ...formData, dateTime: date })}
              showTimeSelect
              dateFormat="dd/MM/yyyy hh:mm aa"
              className="datepicker-input"
              shouldCloseOnSelect={true}
            />
          </label>

          <label>
            Bill Info
            <input
              type="text"
              value={formData.billInfo}
              onChange={(e) =>
                setFormData({ ...formData, billInfo: e.target.value })
              }
              placeholder="Enter Bill Info"
            />
          </label>

          {/* Remarks */}
          <label>
            Remarks
            <input
              type="text"
              value={formData.remarks}
              onChange={(e) =>
                setFormData({ ...formData, remarks: e.target.value })
              }
              placeholder="Enter Remarks"
            />
          </label>
          <label>
            Coins
            <div className="coins-input-wrapper">
              <input
                type="text"
                value={formData.coins}
                onChange={(e) =>
                  setFormData({ ...formData, coins: e.target.value })
                }
                placeholder="Enter Coins"
              />
              <span className="coins-label">Coins</span>
            </div>
          </label>

          {/* Status Dropdown */}
          <label>
            Status
            <select
              value={formData.status}
              onChange={(e) =>
                setFormData({ ...formData, status: e.target.value })
              }
              style={{ padding: "10px", width: "100%", marginTop: "5px" }}
            >
              <option value="Active">Active</option>
              <option value="Deactive">Deactive</option>
            </select>
          </label>

          {/* Buttons */}
          <div className="coinallot-overlay-buttons full-width">
            <button
              className="coin-btn-allot"
              onClick={() => handleSubmit("IN")}
              disabled={loading}
            >
              <span className="symbol">+</span> Allot
            </button>
            <button
              className="coin-btn-deduct"
              onClick={() => handleSubmit("OUT")}
              disabled={loading}
            >
              <span className="symbol">−</span> Deduct
            </button>
            <button type="button" onClick={onClose} disabled={loading}>
              Cancel
            </button>
          </div>
        </form>
      </div>

      <ConfirmPopup
        show={popup.show}
        message={popup.message}
        type={popup.type}
        onClose={handlePopupClose}
      />
    </div>
  );
};

export default EditCoinOverlay;
